import type { ThemeOptions } from "@mui/material";

import { MuiCssBaseline } from "./css-baseline";

export const components: Required<ThemeOptions>["components"] = {
  MuiCssBaseline,
};
